var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileReady)?_c('iframe',{style:(("width:100%; height:calc(100vh - " + _vm.minusHeight + "px);")),attrs:{"src":("https://view.officeapps.live.com/op/embed.aspx?src=" + (_vm.file.link))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }